<style>
  footer {
    clear: both;
    font-size: 0.8em;
    text-align: center;
  }
  footer p {
    margin: 1em;
  }
</style>

<footer>
  <p class="disclaimer">
    Addresses and postcodes are approximate.
    Blue circle is search result,
    smaller red circle is search position (reverse geocoding).
  </p>
  <p class="copyright">
    &copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors
  </p>
</footer>
